module.exports = __webpack_public_path__ + "f568ce7a772df99b45227b196af91906.png";